import React ,{Component} from 'react'
import Header from './Header'
import Footer from './Footer'

class OuterLayout extends Component {

    render(){
        return(<>
             <div className="container" style={{height:'100%'}}>
                {this.props.children}
            </div>
           
        </>)
    }
}

export default OuterLayout;